import { PlaceSummary } from "@/types/place"
import { BoundingBox } from "@/types/util"
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "./redux-store"

export interface ChatExploreAreaSliceState {
  places: PlaceSummary[]
  isExploring: boolean
  isStreaming: boolean
  bbox: BoundingBox | undefined
  searchString: string
}

export const chatExploreAreaSliceInitialState: ChatExploreAreaSliceState = {
  places: [],
  isExploring: false,
  isStreaming: false,
  bbox: undefined,
  searchString: "",
}

const chatExploreAreaSlice = createSlice({
  name: "chatExploreAreaSlice",
  initialState: chatExploreAreaSliceInitialState,
  reducers: {
    setAreaPlaces: (state, action: PayloadAction<PlaceSummary[]>) => {
      state.places = action.payload
    },
    addAreaPlaces: (state, action: PayloadAction<PlaceSummary[]>) => {
      state.places.push(...action.payload)
    },
    setAreaStreaming: (state, action: PayloadAction<boolean>) => {
      state.isStreaming = action.payload
    },
    setIsExploringChatArea: (state, action: PayloadAction<boolean>) => {
      state.isExploring = action.payload
    },
    setAreaBbox: (state, action: PayloadAction<BoundingBox | undefined>) => {
      state.bbox = action.payload
    },
    setAreaSearchString: (state, action: PayloadAction<string>) => {
      state.searchString = action.payload
    },
    clearArea: () => chatExploreAreaSliceInitialState,
  },
})

const selectSliceState = (state: RootState) => state.chatExploreAreaSlice

export const selectChatAreaPlaces = createSelector(
  [selectSliceState],
  (state) => state.places
)

export const selectIsExploringChatArea = createSelector(
  [selectSliceState],
  (state) => state.isExploring
)

export const selectChatAreaStreaming = createSelector(
  [selectSliceState],
  (state) => state.isStreaming
)

export const selectChatAreaBbox = createSelector(
  [selectSliceState],
  (state) => state.bbox
)

export const selectChatAreaSearchString = createSelector(
  [selectSliceState],
  (state) => state.searchString
)

export const {
  setAreaPlaces,
  addAreaPlaces,
  setAreaStreaming,
  setIsExploringChatArea,
  setAreaBbox,
  setAreaSearchString,
  clearArea,
} = chatExploreAreaSlice.actions

export default chatExploreAreaSlice
